/**
 * mapErrorToCode — pure helper for the enrollment catch block.
 *
 * Design D4: lives alongside AdminEnrollFacePage; testable without React/DOM.
 * All typed FaceRecognitionError subclasses expose `code` via the base class,
 * so a single instanceof check covers every known error type including
 * EmbeddingTimeoutError (code='EMBEDDING_TIMEOUT').
 */
import { FaceRecognitionError } from '@/modules/attendance/infrastructure/face/errors';

export function mapErrorToCode(err: unknown): string {
  if (err instanceof FaceRecognitionError) return err.code;
  return 'EMBEDDING_FAILED';
}
